<template>
<div>
  <button-download-term-lamps
    :event="event"
    :event-id="eventId"
    :lamps="lamps"
    :customer="customer"
  />
  <upload-term-lamps @update-file="$emit('upload-file', $event)"/>
</div>
</template>

<script>
import ButtonDownloadTermLamps from './ButtonDownloadTermLamps'
import UploadTermLamps from './UploadTermLamps'

export default {
  name: 'action-term-lamps',
  components: { UploadTermLamps, ButtonDownloadTermLamps },
  props: {
    customer: { required: true },
    lamps: { required: true },
    eventId: {},
    event: {
      required: true
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/pages/Lamps/ActionTermLamps.vue